// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowButtonToggleAnimated_root__LcaCZ","up":"ArrowButtonToggleAnimated_up__TOlb8","down":"ArrowButtonToggleAnimated_down__SHEq9"};